export var SaveToCloudStatus;
(function (SaveToCloudStatus) {
    SaveToCloudStatus[SaveToCloudStatus["disabled"] = 0] = "disabled";
    SaveToCloudStatus[SaveToCloudStatus["available"] = 1] = "available";
    SaveToCloudStatus[SaveToCloudStatus["saving"] = 2] = "saving";
    SaveToCloudStatus[SaveToCloudStatus["succeeded"] = 3] = "succeeded";
    SaveToCloudStatus[SaveToCloudStatus["failed"] = 4] = "failed";
})(SaveToCloudStatus || (SaveToCloudStatus = {}));
//# sourceMappingURL=SxSExtendedViewState.js.map